import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '事奉资源',
    links: [
      { name: '讲道资源', path: '/category/sermon-resources' },
      { name: '门徒训练', path: '/category/discipleship-training' },
      { name: '灵命成长', path: '/category/spiritual-growth' },
      { name: '牧养实践', path: '/category/pastoral-practice' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '联系方式', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-book-2-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-semibold text-foreground-950">
                  牧教师
                </span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
                蒙召牧养，装备成长的事奉平台。帮助每一位蒙召者在职场与教会中忠心服侍、扎根真道、牧养群羊。
              </p>
            </div>

            {/* Links */}
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-3">
                  {group.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div className="pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 牧教师. All rights reserved.
            </p>
            <p className="text-xs text-foreground-400">
              因为凡被神的灵引导的，都是神的儿子。— 罗马书 8:14
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}